// Apply a max video bitrate to the outgoing video sender of a peer connection.
// Default: 2.5 Mbps — good balance for 1080p over typical broadband.
const setVideoBitrate = (peerConnection, maxBitrate = 2_500_000) => {
  if (!peerConnection) return;
  const sender = peerConnection
    .getSenders()
    .find((s) => s.track && s.track.kind === "video");
  if (!sender) return;

  const params = sender.getParameters();
  if (!params.encodings || params.encodings.length === 0) {
    params.encodings = [{}];
  }
  params.encodings[0].maxBitrate = maxBitrate;

  sender.setParameters(params).catch((err) => {
    console.warn("Impossible d'appliquer le bitrate vidéo:", err);
  });
};

// Prefer VP9 (better quality at equal bitrate) on every video transceiver.
// Falls back silently when the API or codec is unavailable.
const preferVP9Codec = (peerConnection) => {
  // Neutralisé : suspecté d'effets de bord sur Safari iOS (audio cassé côté assuré).
  return;
  // eslint-disable-next-line no-unreachable
  if (!peerConnection || typeof RTCRtpSender === "undefined") return;
  if (typeof RTCRtpSender.getCapabilities !== "function") return;

  const capabilities = RTCRtpSender.getCapabilities("video");
  if (!capabilities || !capabilities.codecs) return;

  const vp9 = capabilities.codecs.filter((c) =>
    c.mimeType.toLowerCase().includes("vp9")
  );
  const others = capabilities.codecs.filter(
    (c) => !c.mimeType.toLowerCase().includes("vp9")
  );

  if (vp9.length === 0) return;

  const ordered = [...vp9, ...others];

  peerConnection.getTransceivers().forEach((transceiver) => {
    const isVideo =
      (transceiver.sender && transceiver.sender.track && transceiver.sender.track.kind === "video") ||
      (transceiver.receiver && transceiver.receiver.track && transceiver.receiver.track.kind === "video");
    if (isVideo && typeof transceiver.setCodecPreferences === "function") {
      try {
        transceiver.setCodecPreferences(ordered);
      } catch (err) {
        console.warn("setCodecPreferences VP9 échoué:", err);
      }
    }
  });
};

export { setVideoBitrate, preferVP9Codec };
